import React from 'react' 
import OnboardingViews from 'views/app-views/OnboardingViews'

export const OnboardingLayout = () => {
  return (
    <div className="auth-container app-auth-container">
      <OnboardingViews />
    </div>
  )
}


export default OnboardingLayout
